import shortid from 'shortid';

import { SessionId } from 'craft/types';

/**
 * A session id is stored inside a brower tab to make sure that they are stable
 * and that we can support multiple tabs for a given customer
 */
export const getSessionId = (): SessionId => {
  if (sessionStorage.tabId) {
    return sessionStorage.tabId;
  }
  sessionStorage.tabId = shortid();
  return sessionStorage.tabId;
};
